h1:after {
  content: "\00a0❧";
}
h1:before {
  content: "❧\00a0";
}
h1,
h3,
h5 {
  text-align: center;
  padding: 10px;
  max-width: 800px;
  margin: 0 auto;
}
h5 {
  font-style: italic;
  font-family: serif;
}

.intro-block {
  max-width: 600px;
  margin: 0.5em auto 1em;
}
.intro-block p {
  text-align: center;
}
